var EditorHolderInterface = function () {
};

module.exports = EditorHolderInterface;

EditorHolderInterface.prototype.getEditorHolderTemplate = function () {
    // return this.getView().getEditorHolderTemplate();
};
